import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { ApiService } from "src/app/services/api.service";
import { STATUS } from "src/app/enums/status.enum";
import { BANKS } from "src/app/enums/bank.enum";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarMessageComponent } from "src/app/components/snackbar-message/snackbar-message.component";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorage } from "src/app/enums/local-storage-key.enum";

@Component({
  selector: "app-method-payment",
  templateUrl: "./method-payment.component.html",
  styleUrls: ["./method-payment.component.css"],
})
export class MethodPaymentComponent implements OnInit {
  lang: string = '';
  payments: any;
  select_payment: string;
  payment_option: string;
  is_select_option: boolean = false;
  is_method_type: boolean;
  orderID: string;
  isACPayment: boolean = false;

  payment: any;
  paymentOption: any;
  paymentInfo: any;
  paymentKey: any;
  action_url: string;

  isLocalBank: boolean = false;
  isCreditCard: boolean = false;
  isKhqrBakong: boolean = false;
  isABA: boolean = false;
  isACLEDA: boolean = false;
  manualClose: boolean = false;

  banks_code = BANKS;
  banks: any;
  htmlString: SafeHtml;
  codeStyle: string;

  isIframeVisible = true;
  isSelectType: boolean = false;
  url: string;
  sourceImg: any;

  images = [
    "visa",
    "mastercard",
    "unionpay",
    "jcb",
    "diner"
  ]

  other = {
    "name": "other",
    "code": "other",
    "channels": [
      "web",
      "mobile",
      "kiosk"
    ]
  }

  @ViewChild('iframeKhqrBakong') iframeRef!: ElementRef<HTMLIFrameElement>;

  constructor(
    private apiService: ApiService,
    private snackbar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private localStorageService: LocalStorageService,
    public dialogRef: MatDialogRef<MethodPaymentComponent>,
    @Inject(DOCUMENT) private document: Document,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.lang == '') {
      this.lang = this.localStorageService.get(LocalStorage.LANG);
    }
    this.orderID = data?._id;
    this.htmlString = this.sanitizer.bypassSecurityTrustHtml(String(data?.payment));
  }

  ngOnInit(): void {
    this.payments = this.data?.banks;
  }

  handleClose() {
    this.is_select_option = false
    this.isLocalBank = false;
  }

  closeIframe() {
    const confirmExit = confirm("Are you sure you want to leave this page?");
    if (confirmExit) {
      this.manualClose = true;
      this.dialogRef.close();
    }
  }

  selectPayment(payment: any, isProcessing = false): void {
    this.is_method_type = isProcessing;
    this.is_select_option = true;

    const { code, banks = [], method_type } = payment ?? {};

    this.select_payment = code;
    if (payment.code.toLowerCase() === BANKS.KHQR) {
      payment.code = BANKS.ACLEDA;
    }

    if (!isProcessing && method_type) {
      this.payment_option = method_type;
    }

    if (banks.length > 0 && code === 'CARD') {
      this.paymentOption = [...banks];

      const BLOCKED_CODES = [BANKS.ACLEDA];

      const isBlocked = this.paymentOption.some((p: any) =>
        BLOCKED_CODES.includes(p.code)
      );

      if (isBlocked && this.paymentOption.length === 1) {
        this.paymentOption = [this.other, ...this.paymentOption];
      }
      return;
    }
    this.dialogRef.close({
      data: {
        ...payment,
        payment_option: this.payment_option?.toLowerCase(),
      }
    });
  }


  get isIframeShown(): boolean {
    return this.is_select_option && !this.manualClose;
  }

  expand() {
    setTimeout(() => {
      const iframe = document.querySelector(`.${this.codeStyle.toLowerCase()}`);
      iframe?.classList.add("expanded");
    }, 2000);
  }

  openErrorMessage(message: string): void {
    this.snackbar.openFromComponent(SnackbarMessageComponent, {
      data: {
        message,
      },
      panelClass: "bg-warn",
      duration: 2000,
    });
  }

  getImages(option: string) {
    return option === 'acleda'
      ? this.images.filter(img => img === 'diner')
      : this.images.filter(img => img != 'diner');
  }

  getDescription(bank?: any): string {
    if (!bank) return '';

    switch (this.lang) {
      case 'kr':
        return bank.description_kr || bank.description_en || '';
      case 'ch':
        return bank.description_ch || bank.description_en || '';
      case 'jp':
        return bank.description_jp || bank.description_en || '';
      case 'en':
      default:
        return bank.description_en || '';
    }
  }
  removePaddingContainer() {
    const container = this.document.querySelector(".mat-dialog-container");
    container?.classList.add("no-padding-container");
  }

  setWidthContainerOther() {
    const dialogContainer = document.querySelector(".mat-dialog-container");
    if (dialogContainer) {
      dialogContainer.classList.add("custom-other-dialog-container");
    }
  }

  setWidthContainerKhqr() {
    const dialogContainer = document.querySelector(".mat-dialog-container");
    if (dialogContainer) {
      dialogContainer.classList.add("custom-khqr-dialog-container");
    }
  }

  addPaddingContainer() {
    const dialogContainer = document.querySelector(".mat-dialog-container");
    if (dialogContainer) {
      dialogContainer.classList.remove("no-padding-container");
    }
  }
}

